const APP_PARAM = 'app';
const DEFAULT_APP = 'polling/2026-2030';

const APP_LOADERS = {
  'polling/2026-2030': () => import('../apps/polling/2026-2030/app.js')
};

let currentAppId = null;
let cleanup = null;

function getParams() {
  return new URLSearchParams(window.location.search);
}

function resolveAppId(params) {
  const raw = (params.get(APP_PARAM) || '').trim();
  return raw || DEFAULT_APP;
}

function renderMissingApp(rootEl, appId) {
  rootEl.textContent = `App no encontrada: ${appId}`;
}

async function mountApp() {
  const rootEl = document.getElementById('app-root');
  if (!rootEl) return;

  const params = getParams();
  const appId = resolveAppId(params);

  if (appId === currentAppId && cleanup) return;

  if (cleanup) {
    cleanup();
    cleanup = null;
  }

  const loader = APP_LOADERS[appId];
  if (!loader) {
    renderMissingApp(rootEl, appId);
    currentAppId = appId;
    return;
  }

  const module = await loader();
  if (typeof module.init !== 'function') {
    renderMissingApp(rootEl, appId);
    currentAppId = appId;
    return;
  }

  const result = await module.init({ rootEl, params });
  cleanup = typeof result === 'function' ? result : null;
  currentAppId = appId;
}

function handlePopState() {
  const appId = resolveAppId(getParams());
  if (appId !== currentAppId) {
    mountApp();
  }
}

function bootstrap() {
  mountApp();
  window.addEventListener('popstate', handlePopState);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}